/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Progress_Report_Group_RegressingInputs */

const en_us2_progress_report_group_regressing = /** @type {(inputs: Progress_Report_Group_RegressingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regressing`)
};

const pt_br2_progress_report_group_regressing = /** @type {(inputs: Progress_Report_Group_RegressingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regredindo`)
};

const es_419_progress_report_group_regressing = /** @type {(inputs: Progress_Report_Group_RegressingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retrocediendo`)
};

const pt_pt2_progress_report_group_regressing = /** @type {(inputs: Progress_Report_Group_RegressingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A regredir`)
};

const fr_fr2_progress_report_group_regressing = /** @type {(inputs: Progress_Report_Group_RegressingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En recul`)
};

const de_de2_progress_report_group_regressing = /** @type {(inputs: Progress_Report_Group_RegressingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fallend`)
};

const it_it2_progress_report_group_regressing = /** @type {(inputs: Progress_Report_Group_RegressingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In calo`)
};

/**
* | output |
* | --- |
* | "Regressing" |
*
* @param {Progress_Report_Group_RegressingInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const progress_report_group_regressing = /** @type {((inputs?: Progress_Report_Group_RegressingInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Progress_Report_Group_RegressingInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_progress_report_group_regressing(inputs)
	if (locale === "es-419") return es_419_progress_report_group_regressing(inputs)
	if (locale === "pt-PT") return pt_pt2_progress_report_group_regressing(inputs)
	if (locale === "fr-FR") return fr_fr2_progress_report_group_regressing(inputs)
	if (locale === "de-DE") return de_de2_progress_report_group_regressing(inputs)
	if (locale === "it-IT") return it_it2_progress_report_group_regressing(inputs)
	return en_us2_progress_report_group_regressing(inputs)
});
export { progress_report_group_regressing as "progress-report.group_regressing" }